import numeral from 'numeral';
import 'numeral/locales';
import moment from 'moment';

export const MONTH_AND_DAY_FORMAT = {
  en: 'MMMM D',
  es: 'D [de] MMMM',
  nl: 'D MMMM',
  de: 'D. MMMM',
  pt: 'D [de] MMMM',
  fr: 'D MMMM'
};

export const SHORT_MONTH_AND_DAY_FORMAT = {
  en: 'MMM D',
  es: 'D [de] MMM',
  nl: 'D MMM',
  de: 'D. MMM',
  pt: 'D [de] MMM',
  fr: 'D MMM'
};

export const SHORT_MONTH_AND_DAY_FORMAT_DIGEST = {
  en: 'MMM D',
  es: 'D MMM',
  nl: 'D MMM',
  de: 'D. MMM',
  pt: 'D MMM',
  fr: 'D MMM'
};

export const MONTH_AND_YEAR_FORMAT = {
  en: 'MMMM YYYY',
  es: 'MMMM YYYY',
  nl: 'MMMM YYYY',
  de: 'MMMM YYYY',
  pt: 'MMMM YYYY',
  fr: 'MMMM YYYY'
};

export const SHORT_MONTH_AND_YEAR_FORMAT = {
  en: 'MMM YY',
  es: 'MMM YY',
  nl: 'MMM YY',
  de: 'MMM YY',
  pt: 'MMM YY',
  fr: 'MMM YY'
};

export const localizeNumeral = (lang) => {
  return (...args) => {
    if (lang === 'nl') {
      numeral.locale('nl-be');
    } else if (lang === 'pt') {
      numeral.locale('pt-pt');
    } else {
      numeral.locale(lang);
    }
    return numeral(...args);
  };
};

export const localizeMoment = (lang) => (...args) => moment(...args).locale(lang);

export function translateTag ({ labels, tag, options }) {
  if (!labels || !labels[tag]) {
    return null;
  }

  if (options && options.with) {
    return labels[tag].replace(/%\((.+?)\)s/g, (_, prop) => options.with[prop]);
  }

  return labels[tag];
}
